import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { isKeyInType } from "plos";
import { ToggleButton } from "plos/src/components/ToggleButton";
import { ToggleButtonGroup } from "plos/src/components/ToggleButtonGroup";
import { useLocalizedNavigate } from "plos/src/hooks/useLocalizedNavigate";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { h2hNavWrapper } from "./h2hNav.css";

type H2HView = "standings" | "matches";

interface H2HNavProps {
  view: H2HView;
  defaultEntry?: number;
}

const H2HNav = ({ view, defaultEntry }: H2HNavProps) => {
  const navigate = useLocalizedNavigate();

  const { t } = useTranslation("leaguesAndCups");

  const { leagueId } = useParams();

  const now = useSelector(getCurrentEvent);

  if (!leagueId || !now) return null;

  const eventId = now.id;
  const defaultEntryParam = defaultEntry ? `default_entry=${defaultEntry}` : "";

  const linksDict: Record<H2HView, { href: string; qs: string }> = {
    matches: {
      href: `/leagues/${leagueId}/matches/h`,
      qs: `?event=${eventId}` + (defaultEntryParam && `&${defaultEntryParam}`),
    },
    standings: {
      href: `/leagues/${leagueId}/standings/h`,
      qs: defaultEntryParam && `?${defaultEntryParam}`,
    },
  };

  const handleViewChange = (keys: Set<Key>) => {
    const selectedView = Array.from(keys)[0];

    if (isKeyInType(linksDict, selectedView)) {
      const { href, qs } = linksDict[selectedView];
      navigate(`${href}${qs}`);
    }
  };

  return (
    <div className={h2hNavWrapper}>
      <ToggleButtonGroup
        selectedKeys={new Set([view])}
        onSelectionChange={handleViewChange}
      >
        <ToggleButton id="matches">
          {t("toggleButton.matches", "Matches")}
        </ToggleButton>
        <ToggleButton id="standings">
          {t("toggleButton.standings", "Standings")}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default H2HNav;
